import Toolbar from "../Toolbar";

const AISaasActive = Toolbar.ActionDnd;

export default AISaasActive;
